<div>
  <!-- Summary bar debajo del título -->
  <app-module-summary-bar [mode]="'orders'" [showPersonalStats]="true"
    [showPrimary]="usuario?.hasPermission('orders', 'create')" [autoLoadDashboard]="true"
    [primaryLabel]="'Create Order'" (primaryClick)="openCreateOrder()" [secondaryLabel]="'Export List'"
    (secondaryClick)="exportExcelFile()" [disabledPrimary]="loading()" [disabledSecondary]="loading()"
    [loadingSecondary]="exporting">
  </app-module-summary-bar>

  <div class="row animated fadeIn" [hidden]="true">
    <div class="col-12">
      <div class="card bg-transparent">
        <div class="card-body bg-transparent border-0">
          <div class="row">
            <div class="col">
              <div class="row g-3 align-items-center">
                <div class="col-auto">
                  <label class="label" for="mgmtOrderSearchId">Order ID</label>
                </div>
                <div class="col-auto">
                  <input id="mgmtOrderSearchId" #input type="text" class="form-control" placeholder="" toUppercase />
                </div>
              </div>
            </div>
            <div class="col">
              <div class="row g-3 align-items-center">
                <div class="col-auto">
                  <label class="label" for="mgmtOrderSearchProject">Project</label>
                </div>
                <div class="col-auto">
                  <input id="mgmtOrderSearchProject" #input type="text" class="form-control" placeholder="" toUppercase />
                </div>
              </div>
            </div>

            <div class="col-2">
              <button class="btn btn-themecolor btn-sm btn-block rounded-pill">
                Search
              </button>
            </div>
            <div class="col-3">
              <button class="btn btn-themecolor btn-sm btn-block rounded-pill">
                Create New Order
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <br />

  <!-- Wijmo. -->
  <div class="flex flex-row items-center gap-2 mb-2 px-1 w-full justify-content-between">

    <div class="flex-1 min-w-0 xl:max-w-2xl">
      <app-search-input [placeholder]="'Order #, Client Name, Sales Rep…'" (searchChange)="onTabletSearch($event)">
      </app-search-input>
    </div>

    <div class="view-toolbar-actions">
      @if (viewMode === ViewMode.GRID) {
      <app-date-filter (filterChange)="onDateFilterChange($event)"></app-date-filter>
      }
      <app-tablet-status-filter [options]="filter_options" [selectedValues]="selected_values"
        (valuesChange)="onStatusFilter($event)" class="shrink-0">
      </app-tablet-status-filter>
      <div *ngIf="!deviceService.isTablet()" class="view-switcher rounded-lg" role="group" aria-label="Toggle view mode">
        <button type="button" class="view-switcher__btn" [class.view-switcher__btn--active]="viewMode === ViewMode.GRID"
          (click)="toggleView(ViewMode.GRID)" title="List View">
          <i class="fa fa-list"></i>
          <span>List</span>
        </button>
        <button type="button" class="view-switcher__btn"
          [class.view-switcher__btn--active]="viewMode === ViewMode.CALENDAR" (click)="toggleView(ViewMode.CALENDAR)"
          title="Calendar View">
          <i class="fa fa-calendar-alt"></i>
          <span>Calendar</span>
        </button>
      </div>
    </div>
  </div>

  @if (viewMode === ViewMode.GRID) {
  <div class="row animated fadeIn">
    <div class="col-12">
      <div class="card p-0">
        <div class="card-body bg-white p-0">
          <div class="row">
            <div class="col">
              <div class="grid-panel position-relative">
                <!-- Tier 8: bloque <wj-flex-grid> con *ngIf="false" eliminado.
                     Solo se renderiza <app-kite-grid>. -->
                <app-kite-grid
                  [columnDefs]="columnDefs"
                  [rowData]="orders()"
                  [loading]="loading()"
                  [gridOptions]="gridOptions"
                  [totalRecords]="totalRecords || 0"
                  [pageSize]="pageSize"
                  (pageChange)="refreshData($event)">
                </app-kite-grid>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  } @else if (viewMode === ViewMode.CALENDAR) {
  <div class="animated fadeIn mt-3">
    <div style="min-height: 800px;">
      <app-orders-calendar [statusFilter]="getStatusFilterString()"></app-orders-calendar>
    </div>
  </div>
  }
</div>